import * as React from "react"


const ArrowDown = ({className, style}: {className?: string, style?: any}) => {
    return  <svg
    className={className}
    style={style}
    version="1.1"
    id="svg39590"
    width="40"
    height="40"
    viewBox="0 0 31.666016 31.999998"
    xmlns="http://www.w3.org/2000/svg">
   <defs
      id="defs39594" />
   <g
      id="g39596"
      transform="rotate(90,15.833008,15.833008)">
     <image
        width="32"
        height="31.333332"
        preserveAspectRatio="none"
        id="image39598" />
     <path
        id="rect39717"
        d="M 0,0.47070312 V 7.3339844 H 19.171875 L 5.640625,20.865234 10.933594,26.160156 25.113281,11.980469 V 31.666016 H 32 V 7.3339844 0.47070312 h -6.886719 z" />
   </g>
 </svg>
 
}

export default ArrowDown